import React from "react";
import importedStyles from "./SeatMapLegend.module.css";
import importedStatusStyles from "./SeatInventoryStatus.module.css";

const styles =
  typeof importedStyles === "undefined"
    ? ({
        editorItem: "",
        editorMarker: "",
        editorAvailableMarker: "",
        editorSelectedMarker: "",
        buyerItem: "",
        buyerMarker: "",
        buyerAvailableMarker: "",
        buyerSelectedMarker: "",
        buyerUnavailableMarker: "",
      } as typeof importedStyles)
    : importedStyles;

const statusStyles =
  typeof importedStatusStyles === "undefined"
    ? ({
        markedSold: "markedSold",
        ticketUnavailable: "ticketUnavailable",
      } as typeof importedStatusStyles)
    : importedStatusStyles;

type SeatMapLegendVariant = "editor" | "buyer";

interface SeatMapLegendProps {
  variant: SeatMapLegendVariant;
  translate: (key: string) => string;
  availableMarkerStyle?: React.CSSProperties;
  selectedMarkerStyle?: React.CSSProperties;
  selectedMarkerTestId?: string;
  showInventoryStatuses?: boolean;
  showMarkedSold?: boolean;
}

const LEGEND_CLASSES = {
  editor: {
    item: styles.editorItem,
    marker: styles.editorMarker,
    availableMarker: styles.editorAvailableMarker,
    selectedMarker: styles.editorSelectedMarker,
  },
  buyer: {
    item: styles.buyerItem,
    marker: styles.buyerMarker,
    availableMarker: styles.buyerAvailableMarker,
    selectedMarker: styles.buyerSelectedMarker,
  },
};

export const SeatMapLegend = ({
  variant,
  translate,
  availableMarkerStyle,
  selectedMarkerStyle,
  selectedMarkerTestId,
  showInventoryStatuses = false,
  showMarkedSold = false,
}: SeatMapLegendProps) => {
  const classNames = LEGEND_CLASSES[variant];

  return (
    <>
      <span className={classNames.item}>
        <span
          aria-hidden="true"
          className={`${classNames.marker} ${classNames.availableMarker}`}
          style={availableMarkerStyle}
        />
        {translate("available")}
      </span>
      <span className={classNames.item}>
        <span
          aria-hidden="true"
          data-testid={selectedMarkerTestId}
          className={`${classNames.marker} ${classNames.selectedMarker}`}
          style={selectedMarkerStyle}
        />
        {translate("selected")}
      </span>
      {variant === "buyer" ? (
        <span className={styles.buyerItem}>
          <span
            aria-hidden="true"
            className={`${styles.buyerMarker} ${styles.buyerUnavailableMarker}`}
          />
          {translate("unavailable")}
        </span>
      ) : null}
      {variant === "editor" && showInventoryStatuses ? (
        <span className={classNames.item}>
          <span
            aria-hidden="true"
            className={`${classNames.marker} ${statusStyles.ticketUnavailable}`}
          />
          {translate("seatingLegendSold")}
        </span>
      ) : null}
      {variant === "editor" && (showInventoryStatuses || showMarkedSold) ? (
        <span className={classNames.item}>
          <span
            aria-hidden="true"
            className={`${classNames.marker} ${statusStyles.markedSold}`}
          />
          {translate("seatingLegendMarkedAsSold")}
        </span>
      ) : null}
    </>
  );
};
